import React from 'react';
import { useLocation } from 'react-router';

// Util import
import {
    defaultPanelFilters,
    maisCarrinhoFilters,
} from '~/util/ordersPanelArrays';
import {
    applyOrdersFilter,
    applySearchFilter,
    applyBrandFilter,
    getListByFilter,
    getCartsListByFilter,
} from '~/util/orderPanelFunctions';

import * as Style from './styles';

function FilterButtons({
    orders,
    filter,
    setFilter,
    ordersFilter,
    setOrdersFilter,
    brandFilter,
    searchFilter
}) {
    const location = useLocation().pathname;

    const getFiltersList = () => {
        if (location === '/storeOmni') return defaultPanelFilters.slice(0, 3);
        if (location === '/maisCarrinho') return maisCarrinhoFilters;
        return defaultPanelFilters;
    };

    const filtersList = getFiltersList();

    const getFilterQuantity = filterName => {
        let getFilteredList;
        if (location === '/maisCarrinho') {
            getFilteredList = getCartsListByFilter(orders, filterName);
        } else {
            getFilteredList = getListByFilter(orders, filterName);

            if (ordersFilter && ordersFilter !== 'allOrders') {
                getFilteredList = applyOrdersFilter(
                    getFilteredList,
                    ordersFilter
                );
            }
            
            if (searchFilter) {
                getFilteredList = applySearchFilter(
                    getFilteredList, 
                    searchFilter
                );
            }

            getFilteredList = applyBrandFilter(getFilteredList, brandFilter);
        }
        return getFilteredList?.length;
    };

    const handleClick = filterName => {
        if (location === '/maisCarrinho') {
            setFilter(filterName);
            return;
        }

        if (
            filterName !== 'Todos' &&
            filterName !== 'Vendas' &&
            ordersFilter !== 'allOrders'
        ) {
            setOrdersFilter('allOrders');
        }

        setFilter(filterName);
    };

    return (
        <Style.PillsFilterContainer>
            {filtersList.map(filterName => (
                <Style.StyledButtonPill
                    key={`pill-filter-${filterName} `}
                    primary={filterName === filter}
                    variant={filterName === filter ? 'contained' : 'outlined'}
                    size="medium"
                    onClick={() => {
                        handleClick(filterName);
                    }}
                >
                    {getFilterQuantity(filterName) !== undefined
                        ? `${filterName} (${getFilterQuantity(filterName)})`
                        : filterName}
                </Style.StyledButtonPill>
            ))}
        </Style.PillsFilterContainer>
    );
}

export default FilterButtons;
